import PropTypes from 'prop-types';

import CrmAddressCard from '#/modules/crmMgmt/components/CrmAddressCard';
import CrmCustomerSnapshotMeta from '#/modules/crmMgmt/components/CrmCustomerSnapshotMeta';
import { CUSTOMER_ORDER_STATUS } from '#/modules/crmMgmt/customerOrder/helper/customerOrderStatus';

const CustomerOrderSnapshotSection = ({ detail }) => {
  const status = detail?.status;
  const isPreApprove = (
    status === CUSTOMER_ORDER_STATUS.DRAFT
    || status === CUSTOMER_ORDER_STATUS.SUBMITTED
  );
  const snapshot = detail?.customerSnapshot;

  return (
    <div className="receipt-card-elevate">
      <div className="receipt-card-surface p-5">
        <h2 className="text-base font-semibold text-gray-900">客戶／地址快照</h2>

        {isPreApprove || !snapshot ? (
          <p className="mt-3 text-sm text-muted-foreground">
            核准後才有客戶／地址快照。
          </p>
        ) : (
          <div className="mt-4 space-y-4">
            <CrmCustomerSnapshotMeta snapshot={snapshot} />
            <div className="grid grid-cols-1 gap-3">
              <CrmAddressCard title="帳單地址" address={snapshot.billingAddress} />
              <CrmAddressCard title="收貨地址" address={snapshot.shippingAddress} />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

CustomerOrderSnapshotSection.propTypes = {
  detail: PropTypes.object.isRequired,
};

export default CustomerOrderSnapshotSection;
